import { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AppLayout from "./components/AppLayout";
import { AdminRoute, PrivateRoute, PublicOnlyRoute } from "./components/RouteGuards";
import UpdatePrompt from "./components/UpdatePrompt";
import { PageLoader } from "./components/ui";

const LoginPage = lazy(() => import("./pages/LoginPage"));
const RegisterPage = lazy(() => import("./pages/RegisterPage"));
const ResetPasswordPage = lazy(() => import("./pages/ResetPasswordPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const NewOrderPage = lazy(() => import("./pages/NewOrderPage"));
const HistoryPage = lazy(() => import("./pages/HistoryPage"));
const OrderDetailPage = lazy(() => import("./pages/OrderDetailPage"));
const AccountPage = lazy(() => import("./pages/AccountPage"));
const ContactsPage = lazy(() => import("./pages/ContactsPage"));
const InvitationPage = lazy(() => import("./pages/InvitationPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const PublicLinkPage = lazy(() => import("./pages/PublicLinkPage"));
const PlansPage = lazy(() => import("./pages/PlansPage"));

// Rutas de la versión anterior que pueden estar guardadas como favoritos.
const LEGACY_REDIRECTS = {
  "/orden": "/nueva-orden",
  "/upload-selector": "/enviar",
  "/upload-folder": "/enviar",
  "/upload-photos": "/enviar",
  "/upload-stl": "/enviar",
};

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route element={<PublicOnlyRoute />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
          </Route>
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/invitacion/:token" element={<InvitationPage />} />
          {/* Link de recepción de un laboratorio: público, sin iniciar sesión. */}
          <Route path="/l/:nombre" element={<PublicLinkPage />} />
          {/* Planes y precios: pública; con sesión muestra el plan actual y permite suscribirse. */}
          <Route path="/planes" element={<PlansPage />} />

          <Route element={<PrivateRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/nueva-orden" element={<NewOrderPage key="orden" modo="orden" />} />
              <Route path="/enviar" element={<NewOrderPage key="archivos" modo="archivos" />} />
              <Route path="/historial" element={<HistoryPage />} />
              <Route path="/ordenes/:id" element={<OrderDetailPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/contactos" element={<ContactsPage />} />
              <Route element={<AdminRoute />}>
                <Route path="/admin" element={<AdminPage />} />
              </Route>
            </Route>
          </Route>

          {Object.entries(LEGACY_REDIRECTS).map(([from, to]) => (
            <Route key={from} path={from} element={<Navigate to={to} replace />} />
          ))}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Suspense>
      <UpdatePrompt />
    </BrowserRouter>
  );
}
